// Internal libraries (@stonal-tech/*)
import {
	createBaseStore,
} from '@stonal-tech/lib-front-redux-store-ts';

// Relative imports
import migrations from '@stores/lpdipro/migrations';
import {
	reducers,
} from '@stores/lpdipro/reducers';

export const {
	persistor,
	store,
} = createBaseStore(
	reducers,
	[
		'app',
	],
	{
		migrations,
		version: 18,
	},
);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const dispatch = store.dispatch;
